import moment from 'moment';
import React, { useCallback, useContext } from 'react'
import { Context } from '..';
import { Button } from '@themesberg/react-bootstrap';

export const TableRow = (props) => {
  const {
    createdAt,
    confirmedAt,
    paidAt,
    id,
    price,
    passengerName,
    passengerBirthday,
    passengerBirthPlace,
    passengerIdentify,
    passengerNation,
    seatName,
    seatId,
    ticketClass,
    ticketType,
    routeName,
    routeId,
    boatName,
    departDate,
    departTime,
    status,
    bookPhone,
    bookName,
    document,
  } = props;

  const { state, dispatch } = useContext(Context);

  console.log("props", props)

  const createdString = moment(createdAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()

  const confirmedString = confirmedAt ? moment(confirmedAt).format('DD/MM/YYYY HH:mm').toLocaleString() : ''

  const paidString = paidAt ? moment(paidAt).format('DD/MM/YYYY HH:mm').toLocaleString() : ''

  const departDateString = departDate ? moment(departDate).format('DD/MM/YYYY').toLocaleString() : ''

  const handleCancel = useCallback(() => {
    dispatch({
      type: 'OPEN_CANCEL_POPUP',
      payload: {
        id: id,
      }
    })
  }, [])

  const handleConfirm = useCallback(() => {
    dispatch({
      type: 'OPEN_CONFIRM_POPUP',
      payload: {
        id: id,
      }
    })
  }, [])

  const handleUpdate = useCallback(() => {
    const [h, m] = departTime.split(':')
    const d = new Date(departDate)
    const _t = new Date(d.getFullYear(), d.getMonth(), d.getDate(), parseInt(h), parseInt(m), 0).toISOString()
    dispatch({
      type: 'OPEN_UPDATE_POPUP',
      payload: {
        id: id,
        departDate,
        departTime: _t,
        routeName,
        routeId,
        boatName,
        seatId,
        seatName,
        price,
      }
    })
  }, [])

  return (
    <tr>
      {status === 1 &&
        <td className="text-center">
          <Button variant='warning' onClick={handleUpdate}>
            Sửa vé
          </Button>
          &nbsp;
          <Button variant='danger' onClick={handleCancel}>
            Hủy vé
          </Button>
        </td>
      }
      {status === 2 &&
        <td className="text-center">
        </td>
      }
      {status === 3 &&
        <td className="text-center">
        </td>
      }
      <td className="text-center">
        Tên: <strong className={`text-primary`}>{bookName}</strong><br />
        SĐT: <strong className={`text-primary`}>{bookPhone}</strong><br />
      </td>
      <td>
        Tên: <strong className={`text-primary`}>{passengerName}</strong><br />
        Năm sinh: <strong className={`text-primary`}>{passengerBirthday}</strong><br />
        Nơi sinh: <strong className={`text-primary`}>{passengerBirthPlace}</strong><br />
        CMND/CCCD: <strong className={`text-primary`}>{passengerIdentify}</strong><br />
        Quốc tịch: <strong className={`text-primary`}>{passengerNation}</strong>
      </td>
      <td>
        Tuyến: <strong className={`text-primary`}>{routeName}</strong><br />
        Ngày khởi hành: <strong className={`text-primary`}>{departDateString}</strong><br />
        Giờ khởi hành: <strong className={`text-primary`}>{departTime}</strong><br />
        Tàu: <strong className={`text-primary`}>{boatName}</strong><br />
      </td>
      <td>
        Mã vé: <strong className={`text-primary`}>{id}</strong><br />
        Ghế: <strong className={`text-primary`}>{seatName}</strong><br />
        Hạng ghế: <strong className={`text-primary`}>{ticketClass}</strong><br />
        Loại vé: <strong className={`text-primary`}>{ticketType}</strong><br />
        Giá vé: <strong className={`text-primary`}>{new Intl.NumberFormat('vn-VI', {}).format(price) || ""}</strong>
      </td>
      <td>
        Ngày tạo: <strong className={`text-primary`}>{createdString}</strong><br />
        Ngày thanh toán: <strong className={`text-primary`}>{paidString}</strong><br />
        Ngày xuất vé: <strong className={`text-primary`}>{confirmedString}</strong><br />
      </td>
      <td className={`text-center${status == 1 ? ' text-danger' : status == 2 ? ' text-success' : ' text-warning'}`}>{status == 1 ? 'Đang chờ' : status == 2 ? 'Xong' : 'Đã hủy'}</td>
    </tr>
  );
};